import { apiService } from './apiService';

export interface SpotDriverLocationLog {
  id: number;
  driverId: number;
  shipmentId: number | null;
  shipmentNo: string | null;
  latitude: number;
  longitude: number;
  accuracy: number | null;
  speed: number | null;
  heading: number | null;
  locationDescription: string | null;
  recordedAt: string;
  cekiciPlaka: string;
  dorsePlaka: string;
  driverName: string;
  driverPhone: string;
}

export interface SpotDriverLocationLogResponse {
  success: boolean;
  data: SpotDriverLocationLog[];
  pagination: {
    page: number;
    pageSize: number;
    total: number;
    totalPages: number;
  };
}

class SpotDriverLocationLogService {
  async getLogs(params: {
    from?: string;
    to?: string;
    plate?: string;
    driverName?: string;
    page?: number;
    pageSize?: number | 'all';
  }): Promise<SpotDriverLocationLogResponse> {
    const searchParams = new URLSearchParams();
    if (params.from) searchParams.set('from', params.from);
    if (params.to) searchParams.set('to', params.to);
    if (params.plate) searchParams.set('plate', params.plate);
    if (params.driverName) searchParams.set('driverName', params.driverName);
    if (params.page) searchParams.set('page', String(params.page));
    if (params.pageSize) searchParams.set('pageSize', String(params.pageSize));

    const query = searchParams.toString();
    const url = `/spot-driver-location-logs/logs${query ? `?${query}` : ''}`;
    const response = await apiService.get<SpotDriverLocationLogResponse>(url);
    return response.data;
  }
}

export const spotDriverLocationLogService = new SpotDriverLocationLogService();
